import { AfterViewInit, Component } from '@angular/core';

@Component({
    selector: 'om-identify-toggle',
    templateUrl: './identify-toggle.component.html',
    styleUrls: ['./identify-toggle.component.css']
})

export class IdentifyToggleComponent implements AfterViewInit {

    layers: any[];
    window: any;
    isDefaultView = false;

    ngAfterViewInit() {
        this.window = document.getElementById('identifyToggleWindow');
        if (this.window) {
            this.window.addEventListener('openChange', (open: any) => {
                if (open.detail) {
                    this.windowOpened();
                } else {
                    this.layers = [];
                }
            });
        } else {
            this.windowOpened();
        }
    }

    close() {
        this.window.close();
    }

    windowOpened() {
        this.layers = [];
        const mapRef = document.getElementById('mc-map') as any;
        for (const layer of mapRef.map.layers.toArray() as any[]) {
            if (layer.mapcoreProps) {
                if (layer.mapcoreProps.identifyEnabled === undefined && !layer.mapcoreProps.hideInLegend) {
                    layer.mapcoreProps.identifyEnabled = true;
                }
                if (!layer.mapcoreProps.hideInLegend && !layer.hideInLegend) {
                    this.layers.push(layer);
                }
            }
        }
        this.layers.reverse();
    }

    setAll(value: boolean) {
        for (const layer of this.layers) {
            layer.mapcoreProps.identifyEnabled = value;
        }
    }

}
